import React from "react"

import "./body.scss"

const Body = ({ children }) => <div className="Body">{children}</div>

export default Body
